// Offline support for the till recall checklist: last server snapshot + queued "pulled" ticks.
import api from './api';
import { encryptValue, decryptValue } from './offlineCrypto';
import { getSetting, saveSetting } from './offlineDB';

const QUEUE = 'pending_recall_pulls';
const SNAPSHOT = 'recall_on_shelf_snapshot';
let syncing = false;

const read = async (key, fallback) => {
  const enc = await getSetting(key);
  return enc ? ((await decryptValue(enc)) ?? fallback) : fallback;
};
const write = async (key, value) => saveSetting(key, await encryptValue(value));

export const pullKey = (productId, batchNumber) => `${productId}|${(batchNumber || '').toLowerCase()}`;

export const saveShelfSnapshot = (data) => write(SNAPSHOT, data).catch(() => {});
export const getShelfSnapshot = () => read(SNAPSHOT, null).catch(() => null);
export const getQueuedPulls = () => read(QUEUE, []).catch(() => []);

export const queuePull = async (productId, batchNumber, byName) => {
  const rows = await getQueuedPulls();
  if (rows.some((r) => pullKey(r.product_id, r.batch_number) === pullKey(productId, batchNumber))) return;
  await write(QUEUE, [...rows, {
    product_id: productId, batch_number: batchNumber || '', pulled_at: new Date().toISOString(),
    pulled_by_name: byName, client_ref: `rpull_offline_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
  }]);
};

export const syncQueuedPulls = async () => {
  if (syncing || !navigator.onLine) return 0;
  const rows = await getQueuedPulls();
  if (!rows.length) return 0;
  syncing = true;
  const done = new Set();
  try {
    for (const r of rows) {
      try {
        const { pulled_by_name, ...body } = r;
        await api.post('/recall-returns/pulls', body);
        done.add(r.client_ref);
      } catch (e) {
        if (e?.response?.status) done.add(r.client_ref);
      }
    }
    const latest = await getQueuedPulls();
    await write(QUEUE, latest.filter((r) => !done.has(r.client_ref)));
  } finally {
    syncing = false;
  }
  return done.size;
};
